import {isMobile} from '../helpers';
import ClassList from '../lib/classList';

function limit(min, max, current) {
  return Math.min(max, Math.max(min, current));
}

function hasEvent(eventType) {
  return 'on' + eventType in document.documentElement;
}

function isParkMap() {
  return document.querySelector('.park-new') ? true : false;
}

function isHomeMap() {
  return document.querySelector('.home') ? true : false;
}

export default class MapComponent {
  static SELECTOR = {
    viewport: '.js-map-viewport',
    loader: '.js-map-loader',
    layer: '.js-map-layer',
    image: '.js-map-image',
    objects: '.js-map-object',
    objectsHolder: '.map__objects',
    navigator: '.js-map-navigator',
    frame: '.js-map-frame',
    percentage: '.js-map-percentage',
    scale: '.js-map-scale',
    magnifier: '.js-map-magnifier',
    zoomIn: '.js-map-zoom-in',
    zoomOut: '.js-map-zoom-out',
    poppers: '.js-map-popper',
    popperParent: '.map__poppers',
    poppersClose: '.js-map-popper-close'
  };

  static CLASS_NAME = {
    ready: 'is-ready',
    grabbing: 'is-grabbing',
    pinTop: 'pin-top',
    pinRight: 'pin-right',
    pinBottom: 'pin-bottom',
    pinLeft: 'pin-left',
    tooltipLeft: 'tooltip-left',
    tooltipRight: 'tooltip-right',
    isFixed: 'is-fixed'
  };

  static PARAMS = {
    threshold: 15,
    zoomMin: 100,
    zoomMax: 400,
    scaleMin: 200,
    scaleMax: 50,
    scaleRound: 25,
    scale: 10 / 3 // масштаб картинки (метры)
  };

  static EVENTS_ALL = {
    START: {
      pointer: 'pointerdown',
      touch: 'touchstart',
      ms: 'MSPointerDown',
      mouse: 'mousedown'
    },
    MOVE: {
      pointer: 'pointermove',
      touch: 'touchmove',
      ms: 'MSPointerMove',
      mouse: 'mousemove'
    },
    END: {
      pointer: 'pointerup',
      touch: 'touchend',
      ms: 'MSPointerUp',
      mouse: 'mouseup'
    },
    CANCEL: {
      pointer: ['pointercancel', 'pointerleave'],
      touch: 'touchcancel',
      ms: 'MSPointerCancel',
      mouse: 'mouseleave'
    }
  };

  static initAll() {
    document.querySelectorAll('.js-map').forEach(($mapContainer) => {
      new MapComponent($mapContainer);
    });
  }

  static closest($element, selector) {
    var $closest;
    var $parent = $element;

    while ($parent) {
      if ($parent.matches(selector)) {
        $closest = $parent;
        break;
      } else {
        $parent = $parent.parentElement;
      }
    }

    return $closest;
  }

  constructor($container) {
    this.state = {
      visiblePopperId: undefined,
      pointerDown: undefined,
      thresholdPassed: undefined,
      transformX: 0,
      transformY: 0,
      moveX: 0,
      moveY: 0,
      zoom: 100,
      images: {},
      objects: {}
    };

    if (isParkMap()) {
      this.state.zoom = 50;
      MapComponent.PARAMS.zoomMin = 50;
    }

    this.$container = $container;

    this.$viewport = this.$container.querySelector(MapComponent.SELECTOR.viewport);
    this.$layer = this.$container.querySelector(MapComponent.SELECTOR.layer);
    this.$layers = this.$container.querySelectorAll(MapComponent.SELECTOR.layer);
    this.$loader = this.$container.querySelector(MapComponent.SELECTOR.loader);
    this.$image = this.$container.querySelector(MapComponent.SELECTOR.image);
    this.$objects = this.$container.querySelectorAll(MapComponent.SELECTOR.objects);
    this.$navigator = this.$container.querySelector(MapComponent.SELECTOR.navigator);
    this.$frame = this.$container.querySelector(MapComponent.SELECTOR.frame);
    this.$percentage = this.$container.querySelector(MapComponent.SELECTOR.percentage);
    this.$scale = this.$container.querySelector(MapComponent.SELECTOR.scale);
    this.$magnifier = this.$container.querySelector(MapComponent.SELECTOR.magnifier);
    this.$zoomIn = this.$container.querySelector(MapComponent.SELECTOR.zoomIn);
    this.$zoomOut = this.$container.querySelector(MapComponent.SELECTOR.zoomOut);
    this.$poppers = this.$container.querySelectorAll(MapComponent.SELECTOR.poppers);
    this.$popperParent = this.$container.querySelector(MapComponent.SELECTOR.popperParent);
    this.$poppersClose = this.$container.querySelectorAll(MapComponent.SELECTOR.poppersClose);

    this.$container.classList.add(MapComponent.CLASS_NAME.ready);

    if (!document.querySelector('.home')) {
      this.bindEvents();
    }

    if (this.$image.naturalWidth) {
      this.init();
    } else {
      this.$image.onload = () => {
        this.init();
      };
    }
  }

  init() {
    this.preload(this.$image);
    this.resize();
  }

  detectEvents = function () {
    var EVENTS = {};

    Object.keys(MapComponent.EVENTS_ALL).forEach((eventGroupName) => {
      var eventGroup = MapComponent.EVENTS_ALL[eventGroupName];
      Object.keys(eventGroup).forEach((eventType) => {
        var eventNames = eventGroup[eventType];

        if (typeof eventNames === 'string') {
          if (hasEvent(eventNames) && !EVENTS[eventGroupName]) {
            EVENTS[eventGroupName] = eventNames;
            return false;
          }
        } else {
          eventNames.forEach((eventName) => {
            if (hasEvent(eventName)) {
              if (!EVENTS[eventGroupName]) {
                EVENTS[eventGroupName] = eventName;
              } else {
                EVENTS[eventGroupName] += ` ${eventName}`;
              }
            }
          });

          return !EVENTS[eventGroupName];
        }
      });
    });

    return EVENTS;
  };

  bindEvents() {
    this.EVENTS = this.detectEvents();

    this.on(
      'click',
      MapComponent.SELECTOR.objects,
      (event) => {
        event.preventDefault();
        var $object = MapComponent.closest(event.target, MapComponent.SELECTOR.objects);
        if ($object) {
          this.togglePopper($object.dataset.popper);
        }
      },
      true
    );

    this.on(
      'click',
      MapComponent.SELECTOR.poppersClose,
      (event) => {
        event.preventDefault();
        this.hidePopper(event.target.dataset.popper);
      },
      true
    );

    this.on(
      'click',
      MapComponent.SELECTOR.layer,
      (event) => {
        var $object = MapComponent.closest(event.target, MapComponent.SELECTOR.objects);

        if (this.state.visiblePopperId && !$object) {
          event.preventDefault();
          this.hidePopper(this.state.visiblePopperId);
        }
      },
      true
    );

    this.on(
      this.EVENTS.START,
      MapComponent.SELECTOR.layer,
      (event) => {
        this.$layer.classList.add(MapComponent.CLASS_NAME.grabbing);

        this.state.pointerDown = true;
        this.state.startX = event.pageX;
        this.state.startY = event.pageY;
      },
      false
    );

    this.on(
      this.EVENTS.MOVE,
      MapComponent.SELECTOR.layer,
      (event) => {
        if (this.state.pointerDown) {
          event.preventDefault();

          var deltaX = event.pageX - this.state.startX;
          var deltaY = event.pageY - this.state.startY;

          if (
            !this.state.thresholdPassed &&
            Math.max(Math.abs(deltaX), Math.abs(deltaY)) > MapComponent.PARAMS.threshold
          ) {
            this.state.thresholdPassed = true;
            this.state.startX = event.pageX;
            this.state.startY = event.pageY;
            this.state.startTransformX = this.state.transformX;
            this.state.startTransformY = this.state.transformY;
          } else if (this.state.thresholdPassed) {
            this.moveTo(this.state.startTransformX + deltaX, this.state.startTransformY + deltaY);
          }
        }
      },
      true
    );

    this.on(
      [this.EVENTS.END, this.EVENTS.CANCEL].join(' '),
      document,
      () => {
        this.state.pointerDown = false;
        this.state.thresholdPassed = false;
        this.$layer.classList.remove(MapComponent.CLASS_NAME.grabbing);
      },
      false
    );

    this.on(
      'resize',
      window,
      () => {
        this.resize();
      },
      false
    );

    this.on(
      'click',
      MapComponent.SELECTOR.zoomIn,
      () => {
        this.zoomIn();
      },
      true
    );

    this.on(
      'click',
      MapComponent.SELECTOR.zoomOut,
      () => {
        this.zoomOut();
      },
      true
    );
  }

  on(types, selector, listener, options) {
    var delegate = true;
    var $container = this.$container;
    if (typeof selector === 'function') {
      options = listener;
      listener = selector;
      delegate = false;
    } else if (typeof selector === 'object') {
      delegate = false;
      $container = selector;
    }
    types.split(' ').forEach((type) => {
      if (delegate) {
        $container.querySelectorAll(selector).forEach((element) => {
          element.addEventListener(type.toLowerCase(), listener, options);
        });
      } else {
        $container.addEventListener(type.toLowerCase(), listener, options);
      }
    });
  }

  preload($image) {
    setTimeout(() => {
      var data = $image.dataset;
      Object.keys(data).forEach((key) => {
        var link = document.createElement('link');
        link.rel = 'preload';
        link.as = 'image';
        link.href = data[key];
        document.head.appendChild(link);

        this.state.images[
          key
            .replace(/[^0-9]/g, '')
            .split()
            .join()
        ] = data[key];
      });
    }, 1000);
  }

  getPopper(popperId) {
    return this.$container.querySelector(
      `${MapComponent.SELECTOR.poppers}[data-popper="${popperId}"]`
    );
  }

  getObject(popperId) {
    return this.$container.querySelector(
      `${MapComponent.SELECTOR.objects}[data-popper="${popperId}"]`
    );
  }

  updateObjectsHeight() {
    const objects = this.$container.querySelector(MapComponent.SELECTOR.objectsHolder);

    if (objects) {
      objects.style.height = `${
        this.$container.querySelector(MapComponent.SELECTOR.image)?.getBoundingClientRect().height
      }px`;
    }
  }

  showPopper(popperId) {
    if (this.state.visiblePopperId) {
      this.hidePopper(this.state.visiblePopperId);
    }

    var $popper = this.getPopper(popperId);

    $popper.setAttribute('aria-hidden', 'false');
    this.state.visiblePopperId = popperId;
    this.$popperParent.style.opacity = 1;

    // setTimeout(function () {
    //   $popper.querySelector(MapComponent.SELECTOR.poppersClose).focus();
    // }, 300);
  }

  hidePopper(popperId) {
    if (popperId === undefined) {
      popperId = this.state.visiblePopperId;
    }

    if (popperId !== undefined) {
      this.state.visiblePopperId = undefined;

      var $popper = this.getPopper(popperId);
      var $object = this.getObject(popperId);
      $popper.setAttribute('aria-hidden', 'true');
      this.$popperParent.style.opacity = 0;
      $object.focus();
    }
  }

  togglePopper(popperId) {
    if (this.state.visiblePopperId === popperId) {
      this.hidePopper(popperId);
    } else {
      this.showPopper(popperId);
    }
  }

  static transform($layer, x, y) {
    var X = parseFloat(x.toFixed(0));
    var Y = parseFloat(y.toFixed(0));
    var property = 'transform';
    var value = `translate3d(${X}px, ${Y}px, 0)`;
    var prefixedProperty = Modernizr.prefixedCSS(property) || property;
    $layer.style[prefixedProperty] = Modernizr.prefixedCSSValue(prefixedProperty, value) || value;
    $layer.style['will-change'] = [prefixedProperty, 'width'].toString();
  }

  moveTo(x, y) {
    var layerDeltaWidth = (this.state.layerWidth - this.state.windowWidth) * -1;
    var layerDeltaHeight = (this.state.layerHeight - this.state.windowHeight) * -1;

    var positionX = limit(layerDeltaWidth, 0, x);
    var positionY = limit(layerDeltaHeight, 0, y);

    this.$layers.forEach((layer) => {
      MapComponent.transform(layer, positionX, positionY);
    });

    this.state.transformX = positionX;
    this.state.transformY = positionY;

    if (this.$frame) {
      var framePositionX =
        (this.state.transformX / this.state.layerWidth) * this.state.frameParentWidth * -1;
      var framePositionY =
        (this.state.transformY / this.state.layerHeight) * this.state.frameParentHeight * -1;
      MapComponent.transform(this.$frame, framePositionX, framePositionY);
    }

    this.$objects.forEach(($object) => this.pinObject($object));

    return {
      x: positionX,
      y: positionY
    };
  }

  zoomTo(zoom) {
    var newZoom = limit(MapComponent.PARAMS.zoomMin, MapComponent.PARAMS.zoomMax, zoom);
    var newZoomFactor = newZoom / 100;

    var imageWidth = this.state.imageWidth;
    var imageHeight = this.state.imageHeight;
    var imageRatio = imageHeight / imageWidth;

    var viewportWidth = this.state.viewportWidth;
    var viewportHeight = this.state.viewportHeight;

    var layerWidth = viewportWidth;
    var layerHeight = viewportWidth * imageRatio;

    if (viewportWidth < imageWidth) {
      layerWidth = imageWidth;
      layerHeight = imageHeight;
    }

    if (layerHeight < viewportHeight) {
      layerHeight = viewportHeight;
      layerWidth = viewportHeight / imageRatio;
    }

    this.state.layerWidth = layerWidth * newZoomFactor;
    this.state.layerHeight = layerHeight * newZoomFactor;

    this.$layers.forEach((layer) => {
      layer.style.width = `${this.state.layerWidth}px`;
      layer.style.height = `${this.state.layerHeight}px`;
    });

    if (this.$frame) {
      var frameWidth = this.state.windowWidth / this.state.layerWidth;
      var frameHeight = this.state.windowHeight / this.state.layerHeight;
      this.$frame.style.width = `${frameWidth * 100}%`;
      this.$frame.style.height = `${frameHeight * 100}%`;
    }

    this.$objects.forEach(($object) => {
      var popperId = $object.dataset.popper;
      if (popperId !== undefined) {
        var transform = $object.style.transform;
        var transforms = transform ? transform.match(/[0-9.-]+/g) : null;

        this.state.objects[popperId] = {
          height: $object.offsetHeight,
          top: (parseFloat($object.style.top) / 100) * this.state.layerHeight,
          left: (parseFloat($object.style.left) / 100) * this.state.layerWidth,
          classList: new ClassList($object.classList),
          transformX: transform ? parseFloat(transforms[1]) : 0,
          transformY: transform ? parseFloat(transforms[2]) : 0
        };
      }
    });

    var transformX =
      ((this.state.transformX - viewportWidth / 2) * newZoom) / this.state.zoom + viewportWidth / 2;
    var transformY =
      ((this.state.transformY - viewportHeight / 2) * newZoom) / this.state.zoom +
      viewportHeight / 2;

    if (newZoom === 100) {
      transformX = (viewportWidth - layerWidth) / 2;
    }

    this.moveTo(transformX, transformY);

    if (this.state.images[newZoom]) {
      this.$loader.hidden = false;

      this.$image.onload = () => {
        requestAnimationFrame(() => {
          this.$loader.hidden = true;
        });
      };

      this.$image.src = this.state.images[newZoom];
    }

    this.$percentage.textContent = `${(MapComponent.PARAMS.zoomMin / newZoom) * 100}`;

    var currentImageScale = this.state.imageWidth / this.$image.offsetWidth;
    var currentScalePixel = MapComponent.PARAMS.scale * currentImageScale;

    var scale =
      Math.round(
        (this.$scale.parentElement.offsetWidth * currentScalePixel) / MapComponent.PARAMS.scaleRound
      ) * MapComponent.PARAMS.scaleRound;
    this.$scale.textContent = `${scale}`;

    this.$zoomIn.disabled = MapComponent.PARAMS.zoomMax === newZoom;
    this.$zoomOut.disabled = MapComponent.PARAMS.zoomMin === newZoom;

    this.state.zoom = newZoom;
    this.$container.dataset['zoom'] = (100 / newZoom) * 100;

    this.updateObjectsHeight();
  }

  zoomIn() {
    if (this.state.zoom < MapComponent.PARAMS.zoomMax) {
      this.zoomTo(this.state.zoom * 2);
    }
  }

  zoomOut() {
    if (this.state.zoom > MapComponent.PARAMS.zoomMin) {
      this.zoomTo(this.state.zoom / 2);
    }
  }

  resize() {
    this.state.windowWidth = window.innerWidth;
    this.state.windowHeight = window.innerWidth * 0.668;

    if (isHomeMap()) {
      this.state.windowHeight = window.innerWidth * 0.43;
    }

    if (isParkMap()) {
      this.state.windowWidth = window.innerWidth * 0.83;
      this.state.windowHeight = window.innerWidth * 0.45;
    }

    if (isMobile()) {
      this.state.windowWidth = window.innerWidth;
      this.state.windowHeight = window.innerHeight * 0.75;
    }

    this.state.viewportWidth = this.$viewport.offsetWidth;
    this.state.viewportHeight = this.$viewport.offsetHeight;

    this.state.layerWidth = this.$layer.offsetWidth;
    this.state.layerHeight = this.$layer.offsetHeight;

    this.state.imageWidth = this.$image.naturalWidth;
    this.state.imageHeight = this.$image.naturalHeight;

    this.state.frameParentWidth = this.$frame.parentElement.offsetWidth;
    this.state.frameParentHeight = this.$frame.parentElement.offsetHeight;

    this.state.pinToElements = [];

    this.state.navigator = {
      top: this.$navigator.offsetTop,
      left: this.$navigator.offsetLeft,
      width: this.$navigator.offsetWidth,
      height: this.$navigator.offsetHeight
    };

    this.state.magnifier = {
      top: this.$magnifier.offsetTop,
      left: this.$magnifier.offsetLeft,
      width: this.$magnifier.offsetWidth,
      height: this.$magnifier.offsetHeight
    };

    this.zoomTo(this.state.zoom);
  }

  pinObject($object) {
    var popperId = $object.dataset.popper;
    var objectData = this.state.objects[popperId];

    var objectLeft = objectData.left;
    var transformX = Math.abs(this.state.transformX);
    var windowWidth = this.state.windowWidth;

    windowWidth = isParkMap() ? windowWidth * 0.83 : windowWidth;

    var padding = {
      top: 100,
      right: 20,
      bottom: 20,
      left: 20
    };

    objectData.classList.remove(
      MapComponent.CLASS_NAME.pinTop,
      MapComponent.CLASS_NAME.pinRight,
      MapComponent.CLASS_NAME.pinBottom,
      MapComponent.CLASS_NAME.pinLeft,
      MapComponent.CLASS_NAME.tooltipLeft,
      MapComponent.CLASS_NAME.tooltipRight,
      MapComponent.CLASS_NAME.isFixed
    );

    var borderLeft = transformX + padding.left;
    if (objectLeft >= borderLeft + windowWidth / 2) {
      objectData.classList.add(MapComponent.CLASS_NAME.tooltipLeft);
    } else {
      objectData.classList.add(MapComponent.CLASS_NAME.tooltipRight);
    }

    // apply className
    if (!objectData.classList.sameAs($object.classList)) {
      objectData.classList.applyTo($object);
    }
  }
}
